import { gql } from 'graphql-tag'

import { addressFields } from '../addressFields'

export const UPDATE_NORMALIZED_ADDRESS = gql`
  mutation updateNormalizedAddress(
    $normalizedAddressId: String!
    $normalizedAddressInput: NewAddressInput!
    $targetOrderId: String!
  ) {
    updateNormalizedAddress(
      normalizedAddressId: $normalizedAddressId
      normalizedAddressInput: $normalizedAddressInput
      targetOrderId: $targetOrderId
    ) {
      ...AddressFields
    }
  }
  ${addressFields}
`
